import {
  CLEAR_EDI_RESPONSE_RECORDS,
  CLEAR_EDI_REQUEST_RECORDS,
} from "../actionTypes/index";

export const clearEdiResponseRecords = () => {
  return {
    type: CLEAR_EDI_RESPONSE_RECORDS,
  };
};
export const clearEdiRequestRecords = () => {
  return {
    type: CLEAR_EDI_REQUEST_RECORDS,
  };
};
